import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { categories } from "@/mocks/data";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/category/reqiu", label: "分类书库" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled ? "bg-background-50/95 shadow-sm backdrop-blur" : "bg-background-50"
      }`}
    >
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        {/* 品牌 Logo（H1 关键词由各页面控制，这里使用品牌名） */}
        <Link to="/" className="flex items-center gap-2" aria-label="漫画岛首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-book-open-line text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-label text-xl font-bold tracking-wide text-primary-700">漫画岛</span>
        </Link>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium transition-colors ${
                  isActive ? "bg-primary-100 text-primary-800" : "text-foreground-700 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-3 md:flex">
          <Link
            to="/category/kehuan"
            className="whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            最新安利
          </Link>
          <Link
            to="/category/lianai"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            找同好讨论
          </Link>
        </div>

        {/* 移动端汉堡按钮 */}
        <button
          type="button"
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 md:hidden"
          onClick={() => setMobileOpen((v) => !v)}
          aria-label="打开菜单"
          aria-expanded={mobileOpen}
        >
          <i className={`${mobileOpen ? "ri-close-line" : "ri-menu-line"} text-2xl`} aria-hidden="true"></i>
        </button>
      </div>

      {/* 移动端菜单 */}
      {mobileOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 md:hidden">
          <nav className="flex flex-col gap-1 py-3" aria-label="移动端主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                onClick={() => setMobileOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm font-medium ${
                    isActive ? "bg-primary-100 text-primary-800" : "text-foreground-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="flex flex-col gap-2">
            <p className="px-1 text-xs font-semibold uppercase tracking-wide text-foreground-400">快速跳转</p>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.id}`}
                  onClick={() => setMobileOpen(false)}
                  className="whitespace-nowrap rounded-full border border-background-300 px-3 py-1.5 text-xs text-foreground-700"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}